import { bendingTemplate } from './bending'
import { chemicalTemplate } from './chemical'
import { collapseTemplate } from './collapse'
import { copperLayerTemplate } from './copperLayer'
import { ctodTemplate } from './ctod'
import { flaringTemplate } from './flaring'
import { flatteningTemplate } from './flattening'
import { fourPointTemplate } from './fourPoint'
import { grainSizeTemplate } from './grainSize'
import { hardenabilityTemplate } from './hardenability'
import { hardnessTemplate } from './hardness'
import { hicTemplate } from './hic'
import { impactTemplate } from './impact'
import { microCleanlinesTemplate } from './microCleanlines'
import { microCleanlinesTemplateD } from './microCleanlinesD'
import { microHardnessTemplate } from './microHardness'
import { microStructureTemplate } from './microStructure'
import { microStructurePhotosTemplate } from './microStructurePhotos'
import { naceATemplate } from './naceA'
import { naceDTemplate } from './naceD'
import { reelingTemplate } from './reeling'
import { searchReportTemplate } from './searchReport'
import { searchReportOrdersTemplate } from './searchReportOrders'
import { tensileTemplate } from './tensile'

const getTemplateWihtID = (template: any[]) => {
  return template.map((item) => {
    return {
      id: item.header.split('.').pop(),
      ...item,
    }
  })
}

export const generateObject = (code: string) => {
  let template: any[] = []
  switch (code) {
    case 'test.four.point':
      template = fourPointTemplate
      break
    case 'test.flattening':
      template = flatteningTemplate
      break
    case 'test.flaring':
      template = flaringTemplate
      break
    case 'test.copper.layer':
      template = copperLayerTemplate
      break
    case 'test.collapse':
      template = collapseTemplate
      break
    case 'test.ctod':
      template = ctodTemplate
      break
    case 'test.bending':
      template = bendingTemplate
      break
    case 'test.hardness':
      template = hardnessTemplate
      break
    case 'test.hic':
      template = hicTemplate
      break
    case 'test.impact.transversal':
      template = impactTemplate
      break
    case 'test.impact.longitudinal':
      template = impactTemplate
      break
    case 'test.microhardness':
      template = microHardnessTemplate
      break
    case 'test.microstructure':
      template = microStructureTemplate
      break
    case 'test.microstructure.with.photos':
    case 'test.microstructure.with.photos.longitudinal':
      template = microStructurePhotosTemplate
      break
    case 'report.cleanliness':
      template = microCleanlinesTemplate
      break
    case 'report.cleanliness_d':
      template = microCleanlinesTemplateD
      break
    case 'test.nace.a':
      template = naceATemplate
      break
    case 'test.nace.d':
      template = naceDTemplate
      break
    case 'test.chemical':
      template = chemicalTemplate
      break
    case 'test.reeling':
      template = reelingTemplate
      break
    case 'test.grain.size':
    case 'test.grain.size.longitudinal':
      template = grainSizeTemplate
      break
    case 'test.hardenability':
      template = hardenabilityTemplate
      break
    case 'test.tensile.transversal':
      template = tensileTemplate
      break
    case 'test.tensile.longitudinal':
      template = tensileTemplate
      break
    case 'test.tensile.transversal_hot':
      template = tensileTemplate
      break
    case 'test.tensile.longitudinal_hot':
      template = tensileTemplate
      break
    case 'searchReport':
      template = searchReportTemplate
      break
    case 'searchReportOrders':
      template = searchReportOrdersTemplate
      break
    default:
      break
  }

  return getTemplateWihtID(template)
}

// {name: 'Flattening', type: 2, typeCode: 'mechanical', id: 'flattening', code: 'test.flattening', sites: ['J', 'B']},
//       {name: 'Flaring', type: 2, typeCode: 'mechanical', id: 'flaring', code: 'test.flaring', sites: ['J', 'B']},
//     {name: 'Copper Layer', type: 3, typeCode: 'metallographic', id: 'copper_layer', code: 'test.copper.layer', sites: ['J', 'B'], selectOne: true},
//     {name: 'Collapse', type: 6, typeCode: 'collapse', id: 'collapse', code: 'test.collapse', sites: ['B']},
//     {name: 'CTOD', type: 2, typeCode: 'mechanical', id: 'ctod', code: 'test.ctod', sites: ['J', 'B'], selectOne: true},
//     {name: 'Bending', type: 2, typeCode: 'mechanical', id: 'bending', code: 'test.bending', sites: ['J', 'B']},
//     {name: 'Hardness', type: 2, typeCode: 'mechanical', id: 'hardness', code: 'test.hardness', sites: ['J', 'B']},
//     {name: 'Four Point', type: 4, typeCode: 'corrosion', id: 'four_point', code: 'test.four.point', sites: ['J', 'B']},
//     {name: 'HIC', type: 4, typeCode: 'corrosion', id: 'hic', code: 'test.hic', sites: ['J', 'B']},
//     {name: 'Impact - Transversal', type: 2, typeCode: 'mechanical', id: 'impact_transversal', code: 'test.impact.transversal', sites: ['J', 'B']},
//     {name: 'Impact - Longitudinal', type: 2, typeCode: 'mechanical', id: 'impact_longitudinal', code: 'test.impact.longitudinal', sites: ['J', 'B']},
//     {name: 'Microhardness', type: 3, typeCode: 'metallographic', id: 'microhardness', code: 'test.microhardness', sites: ['J', 'B']},
//     {name: 'Microstructure', type: 3, typeCode: 'metallographic', id: 'microstructure', code: 'test.microstructure', sites: ['J', 'B']},
//     {name: 'Microstructure with photos', type: 3, typeCode: 'metallographic', id: 'microstructure_photos', code: 'test.microstructure.with.photos', sites: ['J', 'B'], selectOne: true},
//     {name: 'Micro Cleanliness', type: 3, typeCode: 'metallographic', id: 'micro_cleanliness', code: 'report.cleanliness', sites: ['J', 'B']},
//     {name: 'NACE-A', type: 4, typeCode: 'corrosion', id: 'nace_a', code: 'test.nace.a', sites: ['J', 'B']},
//     {name: 'NACE-D', type: 4, typeCode: 'corrosion', id: 'nace_d', code: 'test.nace.d', sites: ['J', 'B']},
//     {name: 'MPI', type: 2, typeCode: 'ndt', id: 'mpi', code: 'test.mpi', sites: ['J', 'B'], selectOne: true},
//     {name: 'Chemical', type: 5, id: 'chemical', typeCode: 'chemical', code: 'test.chemical', sites: ['J', 'B']},
//     {name: 'Reeling', type: 2, typeCode: 'mechanical', id: 'reeling', code: 'test.reeling', sites: ['J', 'B'], selectOne: true},
//     {name: 'Grain Size', type: 3, typeCode: 'metallographic', id: 'grain_size', code: 'test.grain.size', sites: ['J', 'B']},
//     {name: 'Hardenability', type: 2, typeCode: 'mechanical', id: 'hardenability', code: 'test.hardenability',
//         req: ['Variação máx (Max Variation)', 'Dureza máx (Hardness max)', 'Dureza min (Hardness min)'], sites: ['J', 'B']},
//     {name: 'Tensile - Transversal', type: 2, typeCode: 'mechanical', id: 'tensile_transversal', code: 'test.tensile.transversal', sites: ['J', 'B']},
//     {name: 'Tensile - Longitudinal', type: 2, typeCode: 'mechanical', id: 'tensile_longitudinal', code: 'test.tensile.longitudinal', sites: ['J', 'B']},
//     {name: 'Hot Tensile - Transversal', type: 2, typeCode: 'mechanical', id: 'tensile_transversal_hot', code: 'test.tensile.transversal_hot', sites: ['J', 'B']},
//     {name: 'Hot Tensile - Longitudinal', type: 2, typeCode: 'mechanical', id: 'tensile_longitudinal_hot', code: 'test.tensile.longitudinal_hot', sites: ['J', 'B']},
//   ];
